import {InitPage} from "../index";
import * as Toastr from "toastr";
import axios from "axios";

declare var $;
declare var bulkCreateUrl;
declare var bulkModifyUrl;
declare var bulkReleaseUrl;
declare var releaseIndexUrl;
declare var callBackUrl;
declare var baseUrl;

class QualityHold {
    constructor() {
        if (typeof baseUrl === 'string') {
            const urlParams = new URLSearchParams(location.search);
            axios.get(`${baseUrl}/quality_hold_count_async.json?${urlParams}`).then((resp) => this.displayData(resp.data));
        }
    }

    displayData(resp: any) {
        $("#count_step1").text(resp.step1);
        $("#count_step2").text(resp.step2);
        $("#count_step3").text(resp.step3);
    }
    
    init() {
        $("#bulk-create-quality-hold").on("click", () => {
            const epcTagIds = $(".select-item:checked").map(function() {
              return $(this).val();
            }).get();

            if (epcTagIds.length === 0) {
                Toastr.error("No Item Number Selected");
                return;
            }

            $.ajax({
              dataType: "jsonp",
              url: bulkCreateUrl,
              data: {
                epc_tag_ids: epcTagIds,
                callback_url: releaseIndexUrl
              }
            });
        });

        $("#bulk-release").on("click", () => {
            const epcTagIds = $(".select-item:checked").map(function() {
              return $(this).val();
            }).get();

            if (epcTagIds.length === 0) {
                Toastr.error("No Item Number Selected");
                return;
            }

            $.ajax({
              dataType: "jsonp",
              url: bulkReleaseUrl,
              data: {
                quality_hold_allocations: epcTagIds,
                callback_url: callBackUrl
              }
            });
        });

        $("#bulk-modify").on("click", () => {
            const epcTagIds = $(".select-item:checked").map(function() {
                return $(this).data("epc-tag-id");
            }).get();

            if (epcTagIds.length === 0) {
                Toastr.error("No Item Number Selected");
                return;
            }

            //console.log(epcTagIds);
            $.ajax({
                dataType: "jsonp",
                url: bulkModifyUrl,
                data: {
                    epc_tag_ids: epcTagIds,
                    callback_url: callBackUrl
                }
            });
        });

        $(".select-item").on("click", this.enableDisableBtn);

        $("#query").select2({
            allowClear: true
        });
        $("#sub_zone").select2({
            allowClear: true
        });
        $("#qh_reason").select2({
            allowClear: true
        });
        $("#qh_id").select2({
            allowClear: true
        });
        $("#on_hold_by_id").select2({
            allowClear: true
        });
        $("#released_by_id").select2({
            allowClear: true
        });
        $("#per_page_value").select2({
            allowClear: true
        });
        $(".expectedCompleteTime").daterangepicker({
            "singleDatePicker": true,
            "timePicker": false,
            locale: {
                format: "M/DD/YYYY"
            }
        });
        $(".select-item-all").on("click", () => {
            if ($(".select-item-all:checked").length > 0) {
                $(".select-item").prop("checked", true);
            }
            else {
                $(".select-item").prop("checked", false);
            }
            this.enableDisableBtn();
        });
    }

    enableDisableBtn() {
        if ($(".select-item:checked").length > 0) {
            $(".qh-btn").removeAttr("disabled");
            $(".qh-btn").removeClass("disabled");
        }
        else {
            $(".qh-btn").attr("disabled", true);
            $(".qh-btn").addClass("disabled");
        }
        QualityHold.updateTagIds();
    }

    static updateTagIds() {
        if ($("#quality_hold_notes_tags").val() != undefined){
            const epcTagIds = $(".select-item:checked").map(function () {
                return $(this).data("epc-tag-id");
            }).get();

            $("#quality_hold_notes_tags").val(epcTagIds);
        }
    }
}

export function LoadPage() {
    InitPage("quality_hold", () => {
        const qualityHold = new QualityHold();
        qualityHold.init();
    });

    InitPage("production_quality_hold", () => {
        const qualityHold = new QualityHold();
        qualityHold.init();
    });

    InitPage("expired_quality_hold", () => {
        const qualityHold = new QualityHold();
        qualityHold.init();
    });
}
